import { render } from "./ShowAccountBox.vue?vue&type=template&id=29edd4a8&scoped=true"
import script from "./ShowAccountBox.vue?vue&type=script&lang=js"
export * from "./ShowAccountBox.vue?vue&type=script&lang=js"

import "./ShowAccountBox.vue?vue&type=style&index=0&id=29edd4a8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29edd4a8"]])

export default __exports__